import * as types from './mutations-types'

export default {
  [types.setCustomer] (state, customer) {
    state.customer = customer
    if (customer !== '') {
      window.localStorage.setItem('customerEmail', JSON.stringify(state.customer.email))
      if (customer.cpf !== null) {
        window.localStorage.setItem('customerCPF', JSON.stringify(state.customer.cpf))
      }
    }
  },
  [types.setCustomers] (state, customers) {
    state.customers = customers
  },
  [types.setCustomerActive] (state, payload) {
    state.customers[payload.index].status = payload.active
  },
  [types.setFilterCustomer] (state, obj) {
    state.filterCustomers[obj.key] = obj.value
  },
  [types.clearFilterCustomer] (state, key) {
    delete state.filterCustomers[key]
  },
  [types.clearFilterCustomers] (state) {
    state.filterCustomers = {}
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/customers/vuex/mutations.js